import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DemoFlexyModule } from '../demo-flexy-module'
import { DashboardComponent } from './dashboard.component';
import { FormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { RouterModule } from '@angular/router';
import { DashboardAdminModule } from './dashboard-admin/dashboard-admin.module';

@NgModule({
  declarations: [
    DashboardComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    DemoFlexyModule,
    FormsModule,
    NgApexchartsModule,
    DashboardRoutingModule,
    DashboardAdminModule
  ],
  exports: [
    DashboardComponent,
  ]
})
export class DashboardModule { }
